import { themr } from '@friendsofreactjs/react-css-themr';

import ProductItem from './ProductItem';

export default themr('ProductItem')(ProductItem);
